import axiosInstant from "../axiosInstant";

export async function login(ArrayData) {
  const response = await axiosInstant
    .post(`/login`, ArrayData)
    .then((res) => {
      // console.log(res.data);
      return res.data;
    })
    .catch((error) => {

      return error.response.data.errors;
    });
  return response;
}



export async function getProfile() {
  const response = await axiosInstant
    .get(`/user/me`)
    .then((res) => {
      // console.log(res.data);
      return res.data;
    })
    .catch((error) => {

      return error.response.data.errors;
    });
  return response;
}



export async function UpdatePaymentMethod(payment_method_id,userId) {
console.log(payment_method_id,userId)
  try {
    const response = await axiosInstant.post('user/me/update-payment-method', {
    "paymongoId":payment_method_id,
});
    return response.data;
  } catch (error) {
    const res = error?.response?.data;

    if (res?.msg === 'Error') {
      return res;
    } else if (res?.errors) {
      return res.errors;
    } else {
      // Fallback error message
      return { error: 'An unexpected error occurred.' };
    }
  }
}

export async function GetApprovedAuction(auction_id) {
  try {
    const response = await axiosInstant.get(`user/me/approved/${auction_id}`);
    return response.data;
  } catch (error) {
    return error?.response?.data || { error: 'Unexpected error occurred.' };
  }
}


export async function JoinAuction(auction_id) {
  console.log("Joining auction with ID:", auction_id);
  try {
    const response = await axiosInstant.post('user/me/join-auction', {
      auction_id: auction_id
    });
    // console.log("response dito",response.data)
    return response.data;
  } catch (error) {
   // console.log("error dito",error?.response?.data)
    const res = error?.response?.data;

  // Fallback error message
      return error?.response?.data;
    
  }
}




export async function AddNewAccount(payload) {
  try {
    const response = await axiosInstant.post("/user/register", payload);

    console.log(response)
    return response.data;
  } catch (error) {
    if (
      error.response &&
      error.response.data &&
      error.response.data.msg ===
        "Email already Exist! please verify your account"
    ) {
      return {
        success: false,
        msg: error.response.data.msg,
        data: error.response.data.data || {},
      };
    }

    return {
      success: false,
      msg: error.response?.data?.msg || "Something went wrong.",
      errors: error.response?.data?.errors || [],
    };
  }
}


export function getToken(){
const token = localStorage.getItem("token");
return token;
}